export default [
  {
    path: '/app/arge',
    name: 'Arge',
    component: () => import('@/views/Admin/Arge/Index.vue'),
    meta: {
      pageTitle: 'Arge Merkezi',
      breadcrumb: [
        {
          text: 'Arge Merkezi',
          active: true,
        },
      ],
      resource: 'ADMIN_ARGE',
      action: 'read',
    },
  },
]
